





























































































































































































































































































































































































































import {Component, Watch, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {urlWithContour} from "@/helpers/currentContour";
import Modal from "@/components/UI/Modal.vue";
import Search from "@/components/UI/Search.vue";
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IDownload from '@/components/icons/IDownload.vue'
import ITrash from '@/components/icons/ITrash.vue'
import ISwitcher from '@/components/icons/ISwitcher.vue'
import IArrow from '@/components/icons/IArrow.vue'
import IQrcode from '@/components/icons/IQrcode.vue'
import SelectedProduct from '@/components/beta/Settings/SelectedProduct.vue';
import Tooltip from "@/components/UI/Tooltip.vue";
import VueQrcode from 'vue-qrcode'
import FileUpload from "@/components/UI/FileUpload.vue";
import SkeletonTable from "@/components/UI/SkeletonTable.vue";

const products = namespace('products')
const workspace = namespace('workspace')
const dialog = namespace('dialog')
const locale = namespace('locale')

@Component({
  components: {
    SkeletonTable,
    SelectedProduct,
    Modal,
    Search,
    BtnDefault,
    IDownload,
    ITrash,
    ISwitcher,
    IArrow,
    IQrcode,
    Tooltip,
    VueQrcode,
    FileUpload,
  }
})

export default class Products extends Vue {
  @products.Getter('products') protected products: any
  @products.Getter('product') protected product: any
  @products.Getter('exportLink') protected exportLink: any
  @products.Getter('thematics') protected thematics: any

  @products.Action('loadProductsFromServer') protected loadProductsFromServer: any
  @products.Action('addNewProduct') protected addNewProduct: any
  @products.Action('deleteProductFromServer') protected deleteProductFromServer: any
  @products.Action('joinProductToShow') protected joinProductToShow: any

  @products.Action('getProduct') protected getProduct: any

  @products.Action('editProductShow') protected editProductShow: any
  @products.Action('exportProducts') protected exportProductsFromServer: any
  @products.Mutation('spreadNewProductList') protected spreadNewProductList: any

  @workspace.Getter('getPlan') protected getPlan: any
  @workspace.Getter('getCurrentExhibition') protected getCurrentExhibition: any

  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any
  @locale.Getter('getLocale') protected getLocale: any

  get itemSelect() {
    return [{
      "id": 'noid',
      "title": this.$t('products.empty')
    }]
  }

  search: string = ''
  isShowAddProduct: boolean = false
  isShowAddOneProduct: boolean = false
  isShowAddProductCsv: boolean = false
  isShowDeleteProduct: boolean = false
  isShowExportModal: boolean = false
  tab: string = 'tab-1'
  newProduct: any = {
    title: '',
    vendorCode: '',
    description: '',
    promo: [
      {
        title: this.$t('common.link'),
        value: ''
      }
    ],
    characters: []
  }
  newCharacteristic: any = {
    title: '',
    value: ''
  }
  isError: any = {
    main: false,
    title: false,
    newCharacteristicTitle: false,
    newCharacteristicValue: false,
  }
  currentProduct: any = {}
  currentProductQrcode: any = {}
  loading: boolean = false
  allLoading: boolean = false
  isMinTable: boolean = false
  isShowLimitActive: boolean = false
  isShowQrcode: boolean = false
  curProductLink: string = ''
  open: boolean = true
  errorLoad: string | number = 0
  newLoad: string | number = 0
  value: any = null
  link: string = ''

  @Watch('getLocale')
  changeTabLocale() {
    (this.$refs.tabs as any).callSlider();
  }

  get searchProducts() {
    return this.search ? this.products.filter((product: any) => product.title.toLowerCase().includes(this.search.toLowerCase())) : this.products
  }

  get headers() {
    if (this.allLoading) {
      return [
        {text: '', value: 'barcode', sortable: false, align: 'start', width: '70'},
        {text: this.$t('products.table.name'), value: 'name', sortable: false},
        {text: this.$t('products.table.thematic'), value: 'thematic', sortable: false, width: '250'},
        {text: this.$t('products.table.date'), value: 'date', sortable: false, width: '150'},
        {text: '', value: 'delete', sortable: false, width: '56'},
      ]
    } else {
      return [
        {text: '', value: 'barcode', sortable: false, align: 'start', width: '70'},
        {text: this.$t('products.table.name'), value: 'name', sortable: false},
        {text: this.$t('products.table.active'), value: 'active', sortable: false, width: '105'},
        {text: this.$t('products.table.thematic'), value: 'thematic', sortable: false, width: '250'},
        {text: this.$t('products.table.date'), value: 'date', sortable: false, width: '150'},
        {text: '', value: 'delete', sortable: false, width: '56'},
      ]
    }
  }

  get headersMin() {
    return [
      {text: '', value: 'barcode', sortable: false, align: 'start', width: '70'},
      {text: this.$t('products.table.name'), value: 'name', sortable: false},
      {text: '', value: 'delete', sortable: false, width: '56'},
    ]
  }

  get headersCharacteristic() {
    return [
      {text: this.$t('products.modals.add_product.tabs.characteristic.table.name'), value: 'title', sortable: false},
      {text: this.$t('products.modals.add_product.tabs.characteristic.table.value'), value: 'value', sortable: false},
      {text: '', value: 'delete', sortable: false, width: '56'},
    ]
  }

  get countActive() {
    let count = 0
    this.products.forEach((product: any) => {
      if (product.showProduct && product.showProduct.status == 'active') count++
    });
    return count
  }


  async mounted() {
    this.allLoading = true
    await this.loadProductsFromServer({
      params: {
        CompanyCode: this.$route.params.code,
        ShowCode: this.$route.params.showCode
      }
    })
    this.allLoading = false
    window.addEventListener('click', () => {
      this.isShowAddProduct = false
    })
  }

  async exportProducts() {
    this.isShowExportModal = true
    await this.exportProductsFromServer({
      ShowCompanyId: this.getCurrentExhibition.companyParticipation._id
    })
    document.location.href = this.exportLink
    this.isShowExportModal = false
  }

  rowClasses(item: any) {
    return (this.isMinTable && item._id == this.currentProduct._id) ? 'lfs-data-table-active' : ''
  }

  async addProduct() {
    this.loading = true
    this.isError.title = this.newProduct.title == ''
    if (this.isError.title) {
      this.tab = 'tab-1'
    } else {
      await this.addNewProduct({
        params: {
          CompanyCode: this.$route.params.code,
          ShowCode: this.$route.params.showCode
        },
        body: this.newProduct
      }).then(() => {
            this.isShowAddOneProduct = false
            this.tab = 'tab-1'
          })
          .catch((err: any) => {
            alert(err)
          });

      this.newProduct = {
        title: '',
        vendorCode: '',
        description: '',
        promo: [
          {
            title: this.$t('common.link'),
            value: ''
          }
        ],
        characters: []
      }
    }
    this.loading = false
  }

  showModalDeleteProduct(item: any) {
    this.isShowDeleteProduct = true
    this.currentProduct = {...item}
  }

  download() {
    // this.showAddCsvModal = false
    window.location.href = ' https://166123.selcdn.ru/public/Products_sample.xlsx';
  }

  async deleteProduct() {
    this.loading = true
    await this.deleteProductFromServer({
      productId: this.currentProduct._id
    })
    this.isShowDeleteProduct = false
    this.loading = false
    this.isMinTable = false
  }

  deleteCharacter(item: any) {
    this.newProduct.characters.splice(item.index, 1)
  }

  timeConverter(UNIX_timestamp: any) {
    const a = new Date(UNIX_timestamp * 1000);
    const months = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    const year = a.getFullYear();
    const month = this.dable(a.getMonth() + 1);
    const date = this.dable(a.getDate());
    const clock = this.dable(a.getHours())
    const min = this.dable(a.getMinutes())
    const rTime = clock + ':' + min
    const rDate = date + '.' + month + '.' + year;

    return {rDate, rTime};
  }

  dable(num: number) {
    return num < 10 ? '0' + num : num
  }

  addCharacteristic() {
    this.isError.newCharacteristicTitle = this.newCharacteristic.title == ''
    this.isError.newCharacteristicValue = this.newCharacteristic.value == ''
    if (!this.isError.newCharacteristicValue && !this.isError.newCharacteristicTitle) {
      this.newProduct.characters.push({...this.newCharacteristic, index: this.newProduct.characters.length})
      this.newCharacteristic = {
        title: '',
        value: ''
      }
    }
  }

  joinToShow(item: any) {
    if ((this.getPlan == 'free' && this.countActive >= 1) || (this.getPlan == 'business' && this.countActive >= 5)) {
      this.isShowLimitActive = true
    } else {
      this.joinProductToShow({
        showCode: this.$route.params.showCode,
        CompanyCode: this.$route.params.code,
        productId: item._id
      })
    }
  }

  showPlans() {
    this.isShowLimitActive = false
    this.SetFullPlanShow(true)
  }

  changeProductShow(item: any) {
    this.editProductShow({
      params: {
        productId: item.showProduct._id
      },
      body: {
        status: 'inactive'
      }
    })
  }

  showDetails(item: any) {
    this.currentProduct = item
    this.getProduct({
      productId: item._id
    })
    this.isMinTable = true
  }

  changeThematic(item: any) {
    let params = item.showProduct.showThematic._id ? {showThematicId: item.showProduct.showThematic._id} : {showThematicId: item.showProduct.showThematic}
    console.log(params)
    this.editProductShow({
      params: {
        productId: item.showProduct._id
      },
      body: params.showThematicId === 'noid' ? {showThematicId: ''} : params
    })
  }

  showQrcode(item: any) {
    this.curProductLink = `${urlWithContour()}/p/${item.showProduct._id}`
    this.currentProductQrcode = item
    this.isShowQrcode = true
  }

  closeAddProduct() {
    this.isShowAddOneProduct = false
    this.tab = 'tab-1'
  }


  loadFile(value: any) {
    console.log(value);
    this.spreadNewProductList(value.data.products)
    this.isShowAddProductCsv = false

  }

  showAddProductCsv() {
    this.open = true
    this.isShowAddProductCsv = true
    // this.link = ''
  }

  closeOpen() {
    this.open = false
  }

  get getOpen() {
    return this.open
  }

}
